import React from "react";

import { useHistory } from "react-router-dom";

import Analizing from "../../../../../presentation/pages/register-account/analizing-register";

const MakeAnalizing: React.FC = () => {
  const history = useHistory();

  const handleClick = (): void => {
    history.push("/");
    localStorage.clear();
  };

  const props = {
    handleClick,
  };

  return <Analizing {...props} />;
};

export default MakeAnalizing;
